/**
The rotate buttons in the detailed view and their functionality
 */
import React from 'react'
import TouchButton from '../../utils/ope-touch-button'
import AdobeAnalytics from '../../../utils/adobe-analytics'
import SelectorActions from '../../../actions/selector-actions'
import createReactClass from 'create-react-class'


var CropperRotate = createReactClass({
	rotateLeft: function() {
		SelectorActions.rotateImage(this.props.item, -90);
	},

	rotateRight: function() {
		SelectorActions.rotateImage(this.props.item, 90);
	},

	render: function() {
		return (
			<div className="ope-editor__detailed__rotate">
				<TouchButton className="ope-button ope-button--rotate-left" onTap={this.rotateLeft}>
					<div className="ope-icon ope-icon--rotate-left"></div>
				</TouchButton>

				<TouchButton className="ope-button ope-button--rotate-right" onTap={this.rotateRight}>
					<div className="ope-icon ope-icon--rotate-right"></div>
				</TouchButton>
			</div>
		);
	}
});

export default CropperRotate;
